"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const luxon_1 = require("luxon");
const dateFormat = { month: 'short', day: '2-digit' };
const PredicateLabelText = ({ predicate }) => {
    const { value, operator } = predicate;
    const val = Object.values(value).filter((v) => v !== null)[0];
    const valueOperator = Object.keys(value).find((v) => value[v] !== null);
    const outerStyle = Object.assign(Object.assign({ color: src_1.turquoise, lineHeight: '24px', height: 24, display: 'inline' }, src_1.text), src_1.regular);
    const formatText = (v) => {
        if (valueOperator === 'dateTimeValue' || valueOperator === 'dateTimeValues') {
            return (React.createElement("span", null,
                `${luxon_1.DateTime.fromISO(v.toString(), {
                    setZone: true,
                }).toLocaleString(luxon_1.DateTime.DATE_MED)}`,
                React.createElement("span", { style: {
                        color: src_1.charcoal,
                    } }, "\u00A0at\u00A0"),
                `${luxon_1.DateTime.fromISO(v.toString(), {
                    setZone: true,
                }).toLocaleString(luxon_1.DateTime.TIME_SIMPLE)}`));
        }
        if (valueOperator === 'listValue') {
            const list = v;
            return React.createElement("span", null, list.name);
        }
        return React.createElement("span", null, v.toString());
    };
    if (operator === 'GEO_WITHIN') {
        return (React.createElement("div", { style: outerStyle },
            React.createElement("span", { style: {
                    color: src_1.turquoise,
                } },
                "\u00A0",
                `${val[2]}m`),
            React.createElement("span", { style: {
                    color: src_1.charcoal,
                    fontStyle: 'italic',
                } }, "\u00A0of"),
            React.createElement("span", { style: {
                    color: src_1.turquoise,
                } },
                "\u00A0",
                `${val[0]}, ${val[1]}`)));
    }
    if (valueOperator.includes('Values')) {
        return (React.createElement("div", { style: outerStyle }, val.map((v, index) => (React.createElement(React.Fragment, { key: index },
            formatText(v),
            index !== val.length - 1 && (React.createElement("span", { style: {
                    color: src_1.charcoal,
                } }, ",\u00A0")))))));
    }
    return React.createElement("div", { style: outerStyle },
        formatText(val),
        " ");
};
exports.default = PredicateLabelText;
